import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/martina/Desktop/Bigbang/web/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/martina/Desktop/Bigbang/web/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/martina/Desktop/Bigbang/web/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/Users/martina/Desktop/Bigbang/web/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/martina/Desktop/Bigbang/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
